<template>
  <div>
    <div class="home">
      <NavBar :index="4" />
    </div>
    <img src="@/assets/img/label-Ct.png" alt="" style="padding-top: 60px" />
    <div class="phoneBox font18">
      <div style="">
        <div
          id="call"
          style="text-align: left; display: inline-block; padding-top: 30px"
        >
          <p style="margin-bottom: 10px;">
            <img
              src="@/assets/img/p-mark1.png"
              alt=""
              style="margin-right: 10px"
            /><span>联系人：</span>李先生 19166210389 / 0755-84711199
          </p>

          <p style="margin-bottom: 10px;">
            <img
              src="@/assets/img/e-mark2.png"
              alt=""
              style="margin-right: 10px"
            /><span>简历投递邮箱：</span>HR@rihaocpa.com
          </p>
          <div style="display:flex;">
            <div>
              <img
                src="@/assets/img/o-mark3.png"
                alt=""
                style="margin-right: 10px"
              /><span>公司地址：</span>
            </div>
            <div>

            <p>深圳：广东省深圳市南山区高新中一道9号软件大厦9楼912号</p>
            <p>北京：北京市海淀区闵庄路清琴麓院小区20楼1单元101</p>
            <p>广州：广州市越秀区环市东路372号4301单元</p>
            </div>
          </div>
        </div>
      </div>

      <img
        style="margin: 50px auto; padding-bottom: 100px"
        src="@/assets/img/pc/QR-img2.png"
        alt=""
      />
    </div>
    <Footer showBackgroundColor></Footer>
  </div>
</template>
<script>
import NavBar from "@/components/NavBar.vue";
import Footer from "@/components/Footer.vue";
import { isMobile } from "@/assets/js/index";

export default {
  name: "page4",
  components: {
    NavBar,
    Footer,
  },
  mounted() {
    if (isMobile()) {
      this.$router.replace({ name: "mobile" });
    }
  },
};
</script>
<style scoped>
.phoneBox {
  line-height: 30px;
}
#call span {
  color: rgb(10, 150, 221);
  font-weight: 900;
  margin-right: 10px;
}
#call img {
  width: 26px;
  height: 26px;
}
p {
  line-height: 40px;letter-spacing:2px
}
</style>
